/**
 * Domain enum constants — mirrored in Prisma schema.
 * Keep these in sync with packages/database/prisma/schema.prisma enum declarations.
 */
export const USER_ROLES = ["superadmin", "admin", "pos_operator", "stall_staff"];
/**
 * The full set of permission keys a regular "admin" account can be
 * individually granted (via Staff.permissions) or denied. superadmin always
 * has all of these plus "manage:settings"/"manage:feature_flags", which stay
 * hardcoded superadmin-only and are deliberately NOT part of this grantable
 * set. Single source of truth shared by backend enforcement
 * (middleware/auth.ts's requirePermission) and admin-app UI gating
 * (usePermissions.ts) — do not duplicate this list in either place.
 */
export const ADMIN_GRANTABLE_PERMISSIONS = [
    { key: "view:reports", labelZh: "报表分析", labelEn: "Reports & Analytics", labelMs: "Laporan & Analitik", route: "/reports" },
    { key: "manage:menu", labelZh: "菜单管理", labelEn: "Menu Management", labelMs: "Pengurusan Menu", route: "/menu" },
    { key: "manage:vouchers", labelZh: "优惠券", labelEn: "Vouchers", labelMs: "Baucar", route: "/vouchers" },
    { key: "manage:bundles", labelZh: "套餐管理", labelEn: "Bundles", labelMs: "Pek Gabungan", route: "/bundles" },
    { key: "manage:promotions", labelZh: "促销横幅", labelEn: "Promotional Banners", labelMs: "Sepanduk Promosi", route: "/banners" },
    { key: "manage:staff", labelZh: "员工与档口管理", labelEn: "Staff & Stall Management", labelMs: "Pengurusan Kakitangan & Gerai", route: "/staff" },
    { key: "approve:refunds", labelZh: "退款审批", labelEn: "Refund Approval", labelMs: "Kelulusan Bayaran Balik", route: "/refunds" },
    { key: "manage:hours", labelZh: "营业时间", labelEn: "Business Hours", labelMs: "Waktu Perniagaan", route: "/hours" },
    { key: "manage:branding", labelZh: "品牌与法律内容", labelEn: "Branding & Legal Content", labelMs: "Penjenamaan & Kandungan Undang-undang", route: "/legal-content" },
    { key: "manage:customers", labelZh: "顾客管理", labelEn: "Customer Management", labelMs: "Pengurusan Pelanggan", route: "/customers" },
];
export const ORDER_TYPES = ["pickup", "delivery"];
export const ORDER_STATUSES = [
    "new",
    "preparing",
    "ready",
    "out_for_delivery",
    "in_transit",
    "delivered",
    "completed",
    "cancelled",
];
/** Canonical status → background colour used by all apps. */
export const ORDER_STATUS_COLOR = {
    new: "#FF6A00",
    preparing: "#EAB308",
    ready: "#16A34A",
    out_for_delivery: "#3B82F6",
    in_transit: "#3B82F6",
    delivered: "#0D9488",
    completed: "#6B7280",
    cancelled: "#EF4444",
};
export const STALL_STATUSES = ["pending", "preparing", "ready", "rejected"];
export const VOUCHER_TYPES = ["percentage", "fixed", "free_item"];
export const VOUCHER_STATUSES = ["active", "scheduled", "expired", "disabled"];
export const BUNDLE_SCOPES = ["both", "pickup", "delivery"];
export const PAYMENT_METHODS = [
    "visa",
    "fpx",
    "grabpay",
    "cash",
    "ewallet",
    "tng",
    "boost",
];
export const TXN_STATUSES = [
    "pending",
    "success",
    "failed",
    "partial_refund",
    "refunded",
];
export const REFUND_TYPES = ["full", "partial"];
export const REFUND_STATUSES = ["pending", "success", "failed", "rejected"];
/**
 * Allowed order status transitions. Server enforces; illegal transitions → 409 + code 3001.
 */
export const ORDER_TRANSITIONS = {
    new: ["preparing", "cancelled"],
    preparing: ["ready", "cancelled"],
    ready: ["out_for_delivery", "completed"],
    out_for_delivery: ["in_transit", "delivered"],
    in_transit: ["delivered"],
    delivered: ["completed"],
    completed: [],
    cancelled: [],
};
//# sourceMappingURL=enums.js.map